import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import type { LegalDoc } from '../data/legal';
type LegalModalProps = {
  doc: LegalDoc | null;
  onClose: () => void;
};
export function LegalModal({
  doc,
  onClose
}: LegalModalProps) {
  useEffect(() => {
    if (!doc) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [doc, onClose]);
  return <AnimatePresence data-id="element-106" data-mp="1gonlcvwn23d">
      {doc && <div className="fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-6" role="dialog" aria-modal="true" aria-labelledby="legal-modal-titulo" data-id="element-107" data-mp="1hs2h4rjlii9z">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-0 bg-navy-900/70" onClick={onClose} data-id="element-108" data-mp="1apn6uet4b074" />

          <motion.div initial={{
        opacity: 0,
        scale: 0.97,
        y: 16
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.97,
        y: 16
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative flex max-h-[88vh] w-full max-w-2xl flex-col overflow-hidden rounded-t-2xl bg-white shadow-2xl shadow-black/40 sm:max-h-[85vh] sm:rounded-2xl" data-id="element-109" data-mp="1pmeax1dql032">
            <div className="flex items-start justify-between gap-6 border-b border-sand-200 px-6 py-5 sm:px-8" data-id="element-110" data-mp="16qo8xe5t03p6">
              <div data-id="element-111" data-mp="e8ahpxez3fz2">
                <h2 id="legal-modal-titulo" className="font-display text-xl font-extrabold uppercase tracking-tight text-ink sm:text-2xl" data-id="element-112" data-mp="e7qzefleupki">
                  {doc.title}
                </h2>
                <p className="mt-1 text-xs uppercase tracking-[0.14em] text-ink/45" data-id="element-113" data-mp="18huua25ctyd">{doc.updated}</p>
              </div>
              <button type="button" onClick={onClose} aria-label="Cerrar" autoFocus className="-mr-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-ink/50 transition-colors duration-150 ease-out hover:bg-sand-100 hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ember-500" data-id="element-114" data-mp="fzibh2d1ru5l">
                <XIcon aria-hidden="true" className="h-5 w-5" data-id="element-115" data-mp="3oco9nsj1g0d3" />
              </button>
            </div>

            <div className="overflow-y-auto px-6 py-6 sm:px-8" data-id="element-116" data-mp="18l0g8738gpz1">
              <div className="space-y-7" data-id="element-117" data-mp="13nrujwivm3t1">
                {doc.sections.map(section => <section key={section.heading} data-id="element-118" data-mp="1b68478qucd9g">
                    <h3 className="font-display text-base font-bold text-ink" data-id="element-119" data-mp="1b5g6nsdoo5gj">{section.heading}</h3>
                    <div className="mt-2 space-y-3" data-id="element-120" data-mp="1g75kffsaix8b">
                      {section.body.map(paragraph => <p key={paragraph} className="text-sm leading-relaxed text-ink/70" data-id="element-121" data-mp="1285ywh02qygd">
                          {paragraph}
                        </p>)}
                    </div>
                  </section>)}
              </div>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}